import { FormConfirmDialog } from "@/components/FormConfirmDialog";
import { CategoryEditor } from "./CategoryEditor";

import type { Control } from "react-hook-form";
import type { CategoryEditorState } from "./CategoryEditor";

export function CategoryEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<CategoryEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <CategoryEditor control={control} />
    </FormConfirmDialog>
  );
}
